import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logo-s2.svg'
import { contactEmail } from '../../content/csp'

const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const Footer = () => {
  return (
    <footer className="wpo-site-footer">
      <div className="shape-1">
        <svg width="795" height="12" viewBox="0 0 795 12" fill="none">
          <rect width="795" height="12" fill="url(#paint0_linear_1_223)" />
          <defs>
            <linearGradient
              id="paint0_linear_1_223"
              x1="795"
              y1="5.99883"
              x2="9.55538e-10"
              y2="5.99883"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#274DCF" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="shape-2">
        <svg width="795" height="12" viewBox="0 0 795 12" fill="none">
          <rect width="795" height="12" fill="url(#paint0_linear_1_224)" />
          <defs>
            <linearGradient
              id="paint0_linear_1_224"
              x1="2.31964e-06"
              y1="5.99883"
              x2="795"
              y2="5.99898"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#DE2045" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={Logo} alt="Common Sense Politics" />
                </div>
                <p>
                  Common Sense Politics built CSPNow so the political center
                  can talk, take polls, and put those views in front of
                  organizations and elected officials.
                </p>
              </div>
            </div>
            <div className="col col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>On this site</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      About
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/platform">
                      Platform
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/partners">
                      Partners
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/how-it-works">
                      How it works
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/overview">
                      One-pager
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget wpo-service-link-widget">
                <div className="widget-title">
                  <h3>Contact</h3>
                </div>
                <div className="contact-ft">
                  <ul>
                    <li>
                      <i className="fa fa-envelope-o" aria-hidden="true"></i>
                      {contactEmail}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <p className="copyright">
                Copyright &copy; 2026 Common Sense Politics. All Rights
                Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
